import { useAtomValue } from 'jotai'
import { loadable } from 'jotai/utils'
import * as R from 'ramda'
import { FC, ReactNode } from 'react'

import {
  weekDays as _weekDays,
  gakkiNames,
  jigens,
  jigensType,
  weekType,
} from '../@types/timetable'
import {
  filterResultSelector,
  selectedRyoikiLabels,
} from '../atoms/filterState'
import { settingsState } from '../atoms/settingsState'
import { yureStringToGakunen } from '../utils'
import { getColorFromChar } from '../utils/color'

export const TimeTable: FC = () => {
  const tableLoadableAtom = useAtomValue(loadable(filterResultSelector))
  const labelsLoadableAtom = useAtomValue(loadable(selectedRyoikiLabels))

  const { saturday, displayYear } = useAtomValue(settingsState)

  if (tableLoadableAtom.state !== 'hasData') {
    return null
  }
  if (labelsLoadableAtom.state !== 'hasData') {
    return null
  }
  const { table: ryoiki } = tableLoadableAtom.data

  // ['月', '火', '水', '木', '金', '土'] から 土を抜く
  const weekDays = saturday ? R.clone(_weekDays) : R.init(R.clone(_weekDays)) // if (!saturday) {

  const thClassName =
    'border border-gray-200 text-sm font-normal py-3 px-3 bg-gray-100 text-gray-500'
  // const tdClassNameBase = 'border border-gray-200 text-sm text-gray-500'
  const tdClassNameBase =
    'border border-gray-200 text-sm text-gray-500 align-top'
  const tdClassAlignTop = `${tdClassNameBase} py-3 px-3`
  const tdClassAlignMiddle = `${tdClassAlignTop} align-middle`

  const renderHeader = (label: string) => {
    return (
      <tr style={{ textAlign: 'left' }}>
        <th className={`${thClassName} w-20`}>{label}</th>
        {weekDays.map(d => {
          return (
            <th className={`${thClassName} w-32`} key={d}>
              {d}
            </th>
          )
        })}
      </tr>
    )
  }

  const renderData = (w: weekType, jigen: jigensType) => {
    let addClassName = ''
    if (jigen % 2 === 0) {
      addClassName = ' bg-gray-50'
    }
    return (
      <tr key={jigen}>
        <td className={`${tdClassAlignTop}${addClassName}`}>
          <div className="">{jigen}</div>
        </td>

        {weekDays.map(d => {
          return (
            <td
              className={`${tdClassNameBase}${addClassName} px-1 py-1`}
              key={d}
              style={{ height: 40 }}
            >
              {w[d][jigen].map((record, i) => {
                const kamokuBangou = record[0]
                const gakunen = record[4]
                const tani = record[3]
                const kamokuTitle = record[1]
                let bikou = ''
                if (record[10].includes('西暦奇数年度開講')) {
                  bikou = '※西暦奇数年度開講'
                } else if (record[10].includes('西暦偶数年度開講')) {
                  bikou = '※西暦偶数年度開講'
                }

                return (
                  <TagCell
                    kamokuBangou={kamokuBangou}
                    isCentering={false}
                    key={i}
                    displayYear={displayYear}
                  >
                    <div className="w-full">
                      <div className="flex justify-between">
                        <div>{kamokuBangou}</div>
                        <div className="inline-flex items-center py-0.5 px-1.5 rounded text-xs font-medium bg-white text-gray-500">
                          {yureStringToGakunen(gakunen).join(',')}
                        </div>
                      </div>
                      {kamokuTitle} <br /> {tani}単位 <br />
                      <span>{bikou}</span>
                    </div>
                  </TagCell>
                )
              })}
            </td>
          )
        })}
      </tr>
    )
  }

  return (
    <>
      {/* // <div style={{ backgroundColor: 'red', overflowX: 'auto' }}> */}
      {gakkiNames.map(gakkiName => {
        return (
          <table
            key={gakkiName}
            className="mb-5"
            style={{ width: '100%', tableLayout: 'fixed' }}
          >
            <thead>{renderHeader(gakkiName)}</thead>
            <tbody>
              {jigens.map(j => {
                return renderData(ryoiki[gakkiName], j)
              })}
            </tbody>
          </table>
        )
      })}

      <h2 className="text-xl font-semibold py-2">集中講義他</h2>
      <table className="mb-5" style={{ width: '100%' }}>
        <tbody>
          <tr style={{ textAlign: 'left' }}>
            <th className={`${thClassName}`}>年次</th>
            <th className={`${thClassName}`}>学期</th>
            <th className={`${thClassName}`}>期間</th>
            <th className={`${thClassName}`}>科目番号</th>
            <th className={`${thClassName}`}>科目名</th>
            <th className={`${thClassName}`}>単位数</th>
          </tr>

          {R.uniq(ryoiki.その他).map((i, index) => {
            let addClassName = ''
            if (index % 2 === 0) {
              addClassName = ' bg-gray-50'
            }
            const kamokuBangou = i[0]
            return (
              <tr key={index} className="text-sm">
                <td className={`${tdClassAlignMiddle}${addClassName} w-20`}>
                  {yureStringToGakunen(i[4]).join(',')}
                </td>
                <td className={`${tdClassAlignMiddle}${addClassName} w-20`}>
                  {i[5]}
                </td>
                <td className={`${tdClassAlignMiddle}${addClassName} w-20`}>
                  {i[6]}
                </td>
                <td className={`${tdClassAlignMiddle}${addClassName} w-24`}>
                  <TagCell
                    kamokuBangou={kamokuBangou}
                    isCentering={true}
                    displayYear={displayYear}
                  >
                    {kamokuBangou}
                  </TagCell>
                </td>
                {/* <td className={`${tdClassAlignMiddle}${addClassName}`}> */}
                <td
                  className={`${tdClassAlignMiddle}${addClassName}`}
                  style={{ minWidth: 200 }}
                >
                  {i[1]}
                </td>
                <td className={`${tdClassAlignMiddle}${addClassName}`}>
                  {i[3]}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* </div> */}
    </>
  )
}
type TagCellProps = {
  kamokuBangou: string
  children: ReactNode
  isCentering: boolean
  displayYear: number
}
const TagCell: FC<TagCellProps> = (props: TagCellProps) => {
  const { kamokuBangou, children, isCentering, displayYear } = props

  const spanClassName = isCentering
    ? 'inline-flex items-center justify-center px-1 py-1 my-1 rounded-md text-sm font-medium text-gray-500'
    : 'inline-flex pl-2 pr-1 py-1 my-1 rounded-md text-sm font-medium text-gray-500'
  return (
    <div
      onClick={() =>
        window.open(
          `https://kdb.tsukuba.ac.jp/syllabi/${displayYear}/${kamokuBangou}/jpn/`
        )
      }
      className={spanClassName}
      style={{
        cursor: 'pointer',
        backgroundColor: getColorFromChar(kamokuBangou[2]),
        width: '100%',
      }}
    >
      {children}
    </div>
  )
}
